import { useState } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import { MdLock, MdVisibility, MdVisibilityOff } from "react-icons/md";

const EMPTY = { current_password: "", new_password: "", confirm_password: "" };

const PasswordField = ({ id, value, onChange, autoComplete, minLength }) => {
  const [visible, setVisible] = useState(false);

  return (
    <div className="change-password-field">
      <span className="change-password-field__icon" aria-hidden="true">
        <MdLock />
      </span>
      <Form.Control
        id={id}
        type={visible ? "text" : "password"}
        value={value}
        onChange={onChange}
        required
        minLength={minLength}
        autoComplete={autoComplete}
        className="change-password-field__input"
      />
      <button
        type="button"
        className="change-password-field__toggle"
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? "Hide password" : "Show password"}
      >
        {visible ? <MdVisibility /> : <MdVisibilityOff />}
      </button>
    </div>
  );
};

const ChangePasswordModal = ({
  show,
  required = false,
  saving = false,
  error = "",
  onClose,
  onSubmit,
}) => {
  const [form, setForm] = useState(EMPTY);

  const handleClose = () => {
    if (required) return;
    setForm(EMPTY);
    onClose?.();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (form.new_password !== form.confirm_password) {
      onSubmit({ ...form, validationError: "New passwords do not match." });
      return;
    }
    onSubmit(form);
  };

  const handleExited = () => setForm(EMPTY);

  return (
    <Modal
      show={show}
      onHide={handleClose}
      onExited={handleExited}
      centered
      backdrop={required ? "static" : true}
      keyboard={!required}
      className="change-password-modal"
    >
      <Modal.Header closeButton={!required}>
        <Modal.Title>{required ? "Set Your Password" : "Change Password"}</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          {required && (
            <p className="change-password-modal__hint">
              For security, please change the system-generated password before continuing.
            </p>
          )}
          <Form.Group className="mb-3">
            <Form.Label htmlFor="change-password-current">Current Password</Form.Label>
            <PasswordField
              id="change-password-current"
              value={form.current_password}
              onChange={(e) => setForm((p) => ({ ...p, current_password: e.target.value }))}
              autoComplete="current-password"
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label htmlFor="change-password-new">New Password</Form.Label>
            <PasswordField
              id="change-password-new"
              value={form.new_password}
              onChange={(e) => setForm((p) => ({ ...p, new_password: e.target.value }))}
              autoComplete="new-password"
              minLength={6}
            />
            <Form.Text>At least 6 characters</Form.Text>
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label htmlFor="change-password-confirm">Confirm New Password</Form.Label>
            <PasswordField
              id="change-password-confirm"
              value={form.confirm_password}
              onChange={(e) => setForm((p) => ({ ...p, confirm_password: e.target.value }))}
              autoComplete="new-password"
              minLength={6}
            />
          </Form.Group>
          {error && <p className="change-password-modal__error">{error}</p>}
        </Modal.Body>
        <Modal.Footer>
          {!required && (
            <Button variant="outline-secondary" onClick={handleClose} disabled={saving}>
              Cancel
            </Button>
          )}
          <Button type="submit" className="btn-update" disabled={saving}>
            {saving ? "Saving…" : "Update Password"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default ChangePasswordModal;
